<script>
import store from '@/store'
import TeacherDashboard from '@/components/teacher/Dashboard'
import LandingPage from '@/components/admin/LandingPage'
import Dashboard from '@/components/admin/Dashboard'

import {
  viewsLandingPage,
  viewsAdminDashboard
  } from '@/helpers/userAuth'

export default {
  components: {
    TeacherDashboard,
    Dashboard,
    LandingPage
  },
  render(h) {
    const role = store.state.role

    if (viewsLandingPage(role)) {
      return h('LandingPage')
    }
    if (viewsAdminDashboard(role)) {
      return h('Dashboard')
    }
    return h('TeacherDashboard')
  }
}
</script>